var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '@stratascratch/ui';
import './EditorButton.css';
function EditorButton(_a) {
    var { children = undefined, className, tooltip = undefined } = _a, rest = __rest(_a, ["children", "className", "tooltip"]);
    return (_jsxs("div", { className: "EditorButton__container", children: [_jsx("button", Object.assign({ type: "button", className: `EditorButton__button ${className || ''}` }, rest, { children: children })), tooltip && (_jsx(Tooltip, { className: "EditorButton__tooltip", text: tooltip, position: "left" }))] }));
}
export default EditorButton;
//# sourceMappingURL=EditorButton.js.map